/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs', 'sm' ] },
      tokens: { alignItems: 'flex-start', size: 32 }
    },
    { if: { hover: true }, tokens: { borderColor: '#2b8000' } },
    {
      if: { focus: true },
      tokens: { borderColor: '#2b8000', borderWidth: 2 }
    },
    {
      if: { pressed: true },
      tokens: { borderColor: '#1f5c09', borderWidth: 2 }
    }
  ],
  tokens: {
    alignItems: 'center',
    borderColor: '#e3e6e8',
    borderRadius: 4,
    borderWidth: 1,
    containerPaddingTop: 24,
    margin: 4,
    padding: 8,
    selectedBorderColor: '#676e73',
    selectedBorderWidth: 2,
    size: 56
  }
}
export default theme
